import type { SVGProps } from 'react';

export function FeatherIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.6 2.4c1.537 0 3.011.611 4.095 1.695l.206.206A5.8 5.8 0 0 1 21.6 8.396c0 .904-.214 1.785-.608 2.58a.58.58 0 0 1-.348.289l-4.2 1.26a.34.34 0 0 0-.244.33c0 .191.154.345.345.345h1.207c.537 0 .803.645.424 1.024l-.84.84a.6.6 0 0 1-.251.15l-3.038.91a.344.344 0 0 0 .101.675c.496 0 .71.59.293.86a9.6 9.6 0 0 1-5.212 1.54H6.004l-1.8 1.8c-.33.33-.87.33-1.2 0a.85.85 0 0 1 0-1.2l8.996-9c.33-.33.33-.87 0-1.2a.85.85 0 0 0-1.2 0l-5.419 5.42a.34.34 0 0 1-.581-.24A9.6 9.6 0 0 1 7.612 7.99l3.893-3.896A5.8 5.8 0 0 1 15.6 2.4" />
    </svg>
  );
}
